export enum NumberRangeType {
  Greater = 'greater',
  GreaterOrEqual = 'greaterOrEqual',
  Lesser = 'lesser',
  LesserOrEqual = 'lesserOrEqual',
  Equal = 'equal',
  InRange = 'inRange'
}



// WEBPACK FOOTER //
// ./src/shared/numberRange/numberRangeType.ts